import _createCaseFirst_default from "./_createCaseFirst.js";

//#region ../../node_modules/lodash-es/upperFirst.js
/**
* Converts the first character of `string` to upper case.
*
* @static
* @memberOf _
* @since 4.0.0
* @category String
* @param {string} [string=''] The string to convert.
* @returns {string} Returns the converted string.
* @example
*
* _.upperFirst('fred');
* // => 'Fred'
*
* _.upperFirst('FRED');
* // => 'FRED'
*/
var upperFirst = _createCaseFirst_default("toUpperCase");
var upperFirst_default = upperFirst;

//#endregion
export { upperFirst_default as default };
//# sourceMappingURL=upperFirst.js.map